import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Página intermediária do fluxo de vínculo Google (popup).
 * Envia postMessage para a janela opener e fecha.
 */
export default function GoogleOauthPopup() {
  const [params] = useSearchParams();

  useEffect(() => {
    const ok = params.get('google_ok');
    const err = params.get('google_error');
    const payload = err
      ? { type: 'pilot-google-oauth', ok: false, error: err }
      : { type: 'pilot-google-oauth', ok: true, result: ok || 'linked' };

    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(payload, window.location.origin);
      }
    } catch (_) {
      /* ignore */
    }

    const t = window.setTimeout(() => {
      try {
        window.close();
      } catch (_) {
        /* ignore */
      }
    }, 400);

    return () => window.clearTimeout(t);
  }, [params]);

  const err = params.get('google_error');

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, sans-serif',
        color: '#344054',
        padding: 24,
        textAlign: 'center',
      }}
    >
      <p style={{ margin: 0, fontSize: 14 }}>
        {err ? 'Não foi possível vincular. Você pode fechar esta janela.' : 'Conta vinculada. Fechando…'}
      </p>
    </div>
  );
}
